import {
  OBJECTIVES,
  player1Color,
  player2Color,
  PLAYER_1_DEPLOYMENT,
  PLAYER_2_DEPLOYMENT,
} from "./CONST";

const inchToMM = 25.4;
const WIDTH_MM = 48 * inchToMM;
const lineCut = 0;
const labelOffset = 7;

const labelFont = "20px Arial";
const measureFont = "16px Arial";
const deploymentFont1 = "12px Arial";
const deploymentFont2 = "11px Arial";

export const draw = ({
  canvasRef,
  scenario,
  player2,
  selectedObjective,
  showZones,
  showDeployment,
}) => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (showDeployment || true) {
    drawDeployment({
      ctx,
      width: canvas.offsetWidth,
      height: canvas.offsetHeight,
      player2,
      showZones,
    });
  }

  scenario.objectives.forEach((objective) =>
    drawObjective({
      objective,
      ctx,
      height: canvas.offsetHeight,
      width: canvas.offsetWidth,
      player2,
      selectedObjective,
      showZones,
    })
  );
};

const drawDeployment = ({ ctx, player2, width, height, showZones }) => {
  const mmToPixel = width / WIDTH_MM;
  let color;
  let opacity = 0.7;

  // draw player 1 deployment
  color = player1Color;
  ctx.strokeStyle =
    opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;
  ctx.fillStyle =
    opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;
  ctx.beginPath();

  if (player2) {
    // top
    // ctx.moveTo(0, PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel);
    // ctx.lineTo(width, PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel);
    ctx.rect(0, 0, width, PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel);
  } else {
    // bottom
    // ctx.moveTo(0, height - PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel);
    // ctx.lineTo(width, height - PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel);
    ctx.rect(
      0,
      height - PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel,
      width,
      PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel
    );
  }

  // ctx.stroke();
  ctx.fill();

  // draw player 2 deployment
  color = player2Color;
  ctx.strokeStyle =
    opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;
  ctx.fillStyle =
    opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;
  ctx.beginPath();

  if (player2) {
    // bottom
    // ctx.moveTo(0, height - PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel);
    // ctx.lineTo(width, height - PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel);
    ctx.rect(
      0,
      height - PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel,
      width,
      PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel
    );
  } else {
    // top
    // ctx.moveTo(0, PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel);
    // ctx.lineTo(width, PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel);
    ctx.rect(0, 0, width, PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel);
  }

  // ctx.stroke();
  ctx.fill();

  if (showZones) {
    // draw player 1 deployment label
    ctx.font = deploymentFont1;
    ctx.fillStyle = player1Color;
    ctx.beginPath();
    if (player2) {
      // top
      ctx.fillText(
        `${PLAYER_1_DEPLOYMENT}"`,
        3,
        11 + PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel
      );
    } else {
      // bottom
      ctx.fillText(
        `${PLAYER_1_DEPLOYMENT}"`,
        3,
        height - 3 - PLAYER_1_DEPLOYMENT * inchToMM * mmToPixel
      );
    }
    // draw player 2 deployment label
    ctx.font = deploymentFont2;
    ctx.fillStyle = player2Color;
    ctx.beginPath();
    if (player2) {
      // bottom
      ctx.fillText(
        `${PLAYER_2_DEPLOYMENT}"`,
        2,
        height - 3 - PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel
      );
    } else {
      // top
      ctx.fillText(
        `${PLAYER_2_DEPLOYMENT}"`,
        2,
        10 + PLAYER_2_DEPLOYMENT * inchToMM * mmToPixel
      );
    }
  }
};

const drawObjective = ({
  objective,
  ctx,
  height,
  width,
  player2,
  selectedObjective,
  showZones,
}) => {
  // showZones = true;
  const { player, type } = objective;

  const opacity = undefined;
  const fillColor = objective.player === 1 ? player1Color : player2Color;
  const color = objective.player === 1 ? player1Color : player2Color;

  const mmToPixel = width / WIDTH_MM;

  let radius = 0;
  switch (type) {
    case "30":
      radius = (30 * mmToPixel) / 2;
      break;
    case "40":
      radius = (40 * mmToPixel) / 2;
      break;
    case "50":
      radius = (50 * mmToPixel) / 2;
      break;
    case "flag":
      radius = (30 * mmToPixel) / 2;
      break;
    case "cache":
      radius = (30 * mmToPixel) / 2;
      break;
    default:
  }

  const left = objective.left * inchToMM * mmToPixel;
  const right = objective.right * inchToMM * mmToPixel;
  const top = objective.top * inchToMM * mmToPixel;
  const bottom = objective.bottom * inchToMM * mmToPixel;

  const onBottom = (player2 && player === 2) || (!player2 && player === 1);
  let x = 0;
  if (left) {
    x = onBottom ? left : width - left;
    x = x + (onBottom ? radius : -radius);
  } else if (right) {
    x = onBottom ? width - right : right;
    x = x + (onBottom ? -radius : radius);
  }
  let y = 0;
  if (top) {
    y = onBottom ? top : width - top;
    y = y + (onBottom ? radius : -radius);
  } else if (bottom) {
    y = onBottom ? width - bottom : bottom;
    y = y + (onBottom ? -radius : radius);
  }

  ctx.beginPath();

  ctx.strokeStyle =
    opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;
  ctx.fillStyle =
    opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;

  ctx.arc(x, y, radius, 0, 2 * Math.PI);
  ctx.stroke();

  if (showZones) {
    ctx.beginPath();

    ctx.strokeStyle =
      opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;
    ctx.fillStyle =
      opacity !== undefined ? `${color}${hexFromPercent(opacity)}` : color;

    ctx.arc(
      x,
      y,
      OBJECTIVES[objective.type].zone
        ? OBJECTIVES[objective.type].zone * inchToMM * mmToPixel
        : radius,
      0,
      2 * Math.PI
    );

    ctx.stroke();
  }

  if (
    !selectedObjective ||
    (selectedObjective?.id
      ? selectedObjective.id !== objective?.id
      : selectedObjective.type !== type)
  ) {
    return;
  }

  ctx.beginPath();
  ctx.font = measureFont;

  if (onBottom) {
    if (left) {
      ctx.moveTo(0 + lineCut, y);
      ctx.lineTo(x - radius - lineCut, y);

      const textWidth = ctx.measureText(`${objective.left}"`).width;
      const mX = (left - radius) / 2 - textWidth / 2;

      ctx.fillText(`${objective.left}"`, mX, y - 5);
    } else if (right) {
      ctx.moveTo(x + radius + lineCut, y);
      ctx.lineTo(width - lineCut, y);

      const textWidth = ctx.measureText(`${objective.right}"`).width;
      const mX = x + radius + right / 2 - textWidth / 2;

      ctx.fillText(`${objective.right}"`, mX, y - 5);
    }

    if (top) {
      ctx.moveTo(x, y - radius - lineCut);
      ctx.lineTo(x, 0 + lineCut);

      const textHeight = ctx.measureText(`${objective.top}"`).hangingBaseline;
      const mY = top / 2 + textHeight / 2;

      ctx.fillText(`${objective.top}"`, x + 5, mY);
    } else if (bottom) {
      ctx.moveTo(x, y + radius + lineCut);
      ctx.lineTo(x, width - lineCut);

      const textHeight = ctx.measureText(`${objective.bottom}"`)
        .hangingBaseline;
      const mY = y + radius + bottom / 2 + textHeight / 2;

      ctx.fillText(`${objective.bottom}"`, x + 5, mY);
    }
  } else {
    // draw other player, won't do
  }

  ctx.stroke();

  if ((player2 && player === 2) || (!player2 && player === 1)) {
    const text = ctx.measureText(`${OBJECTIVES[type].label}`);

    let _x = x;
    let _y = y;
    if (objective.right) {
      _x -= labelOffset;
      _x -= text.width;
    } else if (objective.left) {
      _x += labelOffset;
    }
    if (objective.top) {
      _y += labelOffset;
      _y += text.hangingBaseline;
    } else if (objective.bottom) {
      _y -= labelOffset;
    }

    ctx.font = labelFont;
    ctx.fillText(`${OBJECTIVES[type].label}`, _x, _y);
  }
};

function hexFromPercent(valNum) {
  var decimalValue = Math.round(valNum * 255);

  if (valNum < 0.07) {
    var hexValue = "0" + decimalValue.toString(16).toUpperCase();
  } else {
    var hexValue = decimalValue.toString(16).toUpperCase();
  }

  return hexValue;
}
